import { useRecoilValue } from 'recoil'
import { IParameter, IParameterGroup, IUnit, IUnitPrefix, TCreateParameterDTO } from './parameters.types'
import parameterGroupsAtom from './parameterGroups.atom'

interface IFormatParameterValueParams {
  value: number
  parameter: IParameter
  unitsMap: Record<IUnit['id'], IUnit>
  unitPrefixesMap: Record<IUnitPrefix['id'], IUnitPrefix>
}
const formatParameterValue = (params: IFormatParameterValueParams) => {
  if (params.value === null || params.value === undefined) {
    return '-'
  }

  let unit = ''
  let unitPrefix = ''

  if (params.parameter.unitId) {
    unit = params.unitsMap[params.parameter.unitId].nameRu
  }
  if (
    params.parameter.unitPrefixId &&
    params.unitPrefixesMap[params.parameter.unitPrefixId].nameRu !== 'без префикса'
  ) {
    unitPrefix = params.unitPrefixesMap[params.parameter.unitPrefixId].nameRu
  }

  return `${params.value.toString()} ${unitPrefix}${unit}`
}

const formatPositionGroupById = (id: IParameterGroup['id']) => {
  const groups = useRecoilValue(parameterGroupsAtom).items
  const findGroup = groups.find((group) => group.id === id)
  return findGroup.name
}

const isCorrectFormParameterFields = (parameter: IParameter | TCreateParameterDTO) =>
  parameter.name !== '' &&
  parameter.sourceId !== '' &&
  parameter.groupId !== null &&
  parameter.dataType !== null &&
  parameter.unitId !== null &&
  parameter.unitPrefixId !== null

const parametersUtils = {
  formatParameterValue,
  formatPositionGroupById,
  isCorrectFormParameterFields,
}

export default parametersUtils
